import { useMutation } from '@tanstack/react-query'

import { api } from '../../../services/api'

export const useLogoutAccount = () =>
  useMutation({
    mutationFn: api.auth.logoutAccount,
    mutationKey: ['logout-account'],
  })
